import { useState } from "react";
import { useSelector } from "react-redux";
import { getActiveUsers } from "@neumetric/blueprint-lib/store";
import { Col, NMPopup, HistoryPopup, Input } from "@neumetric/blueprint-lib/components";

import { getCurrentRisk, getReferenceList } from "../../store";

export const RiskHistoryPopup = ({ onClose }) => {
  const currentRisk = useSelector(getCurrentRisk);
  const history = currentRisk.comments;
  return (
    <HistoryPopup
      visible={true}
      title="Risk History"
      items={history}
      variant="INFO"
      onModalClose={onClose}
      editable={false}
      showClose="icon"
      classes={{ list: "h-350-px" }}
      evalAvator="https://nmlogoicon.s3.ap-south-1.amazonaws.com/Mitigator_EvalHistoryProfileIcon.png"
    />
  );
};

export const RiskReferencesPopup = ({ onClose }) => {
  const references = useSelector(getReferenceList);
  return (
    <NMPopup
      width={480}
      visible={true}
      title="References"
      variant="INFO"
      onModalClose={onClose}
      actions={[
        {
          label: "Close",
          icon: "CANCEL",
          btnType: "CONTAINED",
          onClick: onClose,
        },
      ]}
    >
      <Col className="w-100">
        {references.map((reference, index) => {
          return (
            <a
              key={index}
              href={reference.link}
              rel="noopener noreferrer"
              target="_blank"
              className="ff-exo2 fs-15 line-24 text-action fw-400 reference-link"
            >
              <span>{reference.name}</span>
            </a>
          );
        })}
      </Col>
    </NMPopup>
  );
};

export const RiskConfirmationPopup = (props) => {
  const { onClose, dialogConfig } = props;
  const users = useSelector(getActiveUsers);

  const [state, setState] = useState({
    submitting: false,
    note: "",
    selectedResponder: null,
  });

  const updateState = (newState) => {
    setState({ ...state, ...newState });
  };

  const getInputProps = () => {
    if (dialogConfig.showResponder) {
      return {
        typeRepresentation: "DROPDOWN",
        searchableFlag: true,
        classes: { root: "w-100 mt-16 mb-0" },
        options: users,
        value: state.selectedResponder,
        multiSelection: false,
        label: "Responder",
        labelAlign: "middle",
        onChange: (userId) => updateState({ selectedResponder: userId }),
        placeholder: "search Responder...",
        template: "USER",
        labelTemplate: "LIST",
      };
    }

    if (dialogConfig.showNote) {
      return {
        label: "Note",
        required: true,
        rows: 5,
        layout: "vertical",
        typeRepresentation: "TEXTAREA",
        classes: { root: "w-100 mt-16 mb-0" },
        value: state.note,
        onChange: (value) => updateState({ note: value }),
        placeholder:
          "Example: It has been decided that this Risk will not be treated and the source process that is causing this risk will be terminated.",
      };
    }

    return null;
  };

  const handleConfirm = () => {
    updateState({ submitting: true });
    const responder = dialogConfig.showResponder
      ? users.find((user) => user.id === state.selectedResponder)
      : null;

    dialogConfig.confirm.onClick({ ...dialogConfig }, { responder: responder, note: state.note }, handleCancel);
  };

  const handleCancel = () => {
    updateState({ submitting: false, note: "", selectedResponder: null });
    onClose();
  };

  const getActions = () => {
    const { cancel, confirm } = dialogConfig;

    return [
      {
        btnType: "OUTLINED",
        variant: "ACTION",
        icon: "CANCEL",
        label: "Cancel",
        disabled: state.submitting,
        onClick: onClose,
        ...cancel,
      },
      {
        btnType: "CONTAINED",
        variant: "ACTION",
        label: confirm?.label || "Confirm",
        icon: confirm?.icon || "SEND",
        disabled:
          (dialogConfig.showResponder && state.selectedResponder === null) ||
          (dialogConfig.showNote && state.note.trim() === ""),
        loading: state.submitting,
        ...confirm,
        onClick: handleConfirm,
      },
    ];
  };

  const inputProps = getInputProps();

  return (
    <NMPopup
      visible={true}
      width={dialogConfig.width || 480}
      title={dialogConfig.title}
      variant={dialogConfig.variant || "INFO"}
      actions={getActions()}
      onModalClose={onClose}
      classes={{ root: dialogConfig.className }}
    >
      <Col className="w-100">
        <span className="ff-exo2 fs-15 line-22 text-filled">
          {dialogConfig.description}
        </span>
        {(dialogConfig.showNote || dialogConfig.showResponder) && inputProps && (
          <Input {...inputProps} />
        )}
      </Col>
    </NMPopup>
  );
};

